export default "__VITE_ASSET__vXL2bve6__"